import { toQuery, type HttpClient } from '../client';
import type { RfidLogRow, RfidQuery, RfidReadRequest, RfidReadResult } from '../types/rfid';

const BASE = '/wl/rfid';

/**
 * RFID / 智能柜读取（Hq.Api Inventory）：
 * 设备或手持机批量上报 EPC（可带条码），后端按条码或历史 EPC 映射物资，
 * 未命中的标记 `unrecognized` 供人工绑定；下游盘点/出入库可引用同一批次号。
 */
export function createRfidApi(http: HttpClient) {
  return {
    /** 读取流水：按批号 / 仓库过滤，返回数组（后端不分页游标）。 */
    list(query: RfidQuery = {}): Promise<RfidLogRow[]> {
      return http.request<RfidLogRow[]>({ path: `${BASE}/read`, query: toQuery(query) });
    },

    /** 上报一批读取（幂等：IdempotencyFilter）。 */
    report(body: RfidReadRequest): Promise<RfidReadResult> {
      return http.request<RfidReadResult>({ path: `${BASE}/read`, method: 'POST', body });
    }
  };
}

export type RfidApi = ReturnType<typeof createRfidApi>;
